export default __webpack_public_path__ + "static/media/25 - Paramount 100th - Logo 05.17bd07a1.png";